import { requireClient } from './supabase.js';

/* PERSONALISED VIDEO LINKS — the Admin page's calls.

   Everything goes through the video-links-admin Edge Function: the tables have
   row level security and no policy, so the browser cannot touch them, and the
   function re-checks is_admin() against the caller's own token before it does
   anything (see its header). invoke() attaches the signed-in session's token,
   which is exactly what it verifies — the same arrangement as services/admin.js's
   admin-users calls, including digging the function's own message out of a
   non-2xx response rather than showing a generic one. */
async function call(action, payload = {}) {
  const { data, error } = await requireClient().functions.invoke('video-links-admin', {
    body: { action, ...payload }
  });
  if (error) {
    let msg = '';
    try { msg = (await error.context?.json())?.error || ''; } catch (_) { /* not JSON */ }
    console.error('[illusio] video links ' + action + ' failed', error);
    throw new Error(msg || 'Couldn’t do that. Is the video-links-admin function deployed?');
  }
  if (data && data.error) throw new Error(data.error);
  return data;
}

export const vlOverview = () => call('overview');
export const vlCreateVideo = v => call('create_video', v);
/** A short-lived address to PUT a file to: { url, path, headers }. Needs the R2 secrets on the function. */
export const vlUploadUrl = p => call('upload_url', p);
export const vlCreateCampaign = c => call('create_campaign', c);
export const vlUpdateCampaign = (id, patch) => call('update_campaign', { id, ...patch });
export const vlDeleteCampaign = id => call('delete_campaign', { id });
export const vlAddRecipients = (campaignId, text) => call('add_recipients', { campaign_id: campaignId, text });
export const vlCampaign = (campaignId, includeBots = false) =>
  call('campaign_detail', { campaign_id: campaignId, include_bots: includeBots });
export const vlMarkSent = (linkId, sent) => call('mark_sent', { link_id: linkId, sent });
export const vlSetExpiry = (linkId, expiresAt) => call('set_expiry', { link_id: linkId, expires_at: expiresAt });
export const vlDeleteLink = linkId => call('delete_link', { link_id: linkId });
export const vlDeleteRecipient = email => call('delete_recipient', { email });
